import type { AxiosInstance } from 'axios'

import type { RequestInterceptor } from '@/utils/axios'

export type GetAccessToken = () => Promise<string>

export const onRequest =
  (getAccessToken: GetAccessToken): RequestInterceptor =>
  async config => {
    const accessToken = await getAccessToken()

    config.headers['Authorization'] = `Bearer ${accessToken}`

    return Promise.resolve(config)
  }

export const axiosAuth =
  (getAccessToken: GetAccessToken) => (axiosInstance: AxiosInstance) => {
    axiosInstance.interceptors.request.use(onRequest(getAccessToken))

    return axiosInstance
  }
